import { Ban } from "lucide-react";
import { OFFER_LABELS, PAYMENT_STATUS_LABELS, euro, formatDate, EMPTY_BOX } from "./format";
import { ExportButton } from "./ExportButton";

const SubCard = ({ s, i, onCancel }) => (
  <article data-testid={`admin-sub-card-${i}`} className="rounded-3xl border border-navy/10 bg-white p-6">
    <div className="flex items-start justify-between gap-3">
      <div>
        <p className="font-display text-base font-bold text-navy">{OFFER_LABELS[s.lookup_key] || s.lookup_key || "Abonnement"}</p>
        <p className="mt-0.5 text-sm text-slate-600">{s.email || "Client"}</p>
      </div>
      <span className="shrink-0 font-display text-base font-bold text-gold-dark">
        {euro(s.amount, s.currency)}
        <span className="text-xs font-semibold text-slate-500">{s.interval === "year" ? "/an" : "/mois"}</span>
      </span>
    </div>
    <p className="mt-3 text-xs text-slate-500">Renouvellement : {formatDate(s.current_period_end)}</p>
    {s.transition_to_yearly_at && (
      <p className="mt-1 text-xs font-semibold text-gold-dark" data-testid={`admin-sub-transition-${i}`}>Passage au tarif annuel 35,99 € le {formatDate(s.transition_to_yearly_at)}</p>
    )}
    {s.cancel_at_period_end ? (
      <p className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-navy/5 px-3 py-1.5 text-[11px] font-semibold text-slate-600" data-testid={`admin-sub-cancelled-${i}`}>
        <Ban size={11} /> Résiliation programmée au {formatDate(s.current_period_end)}
      </p>
    ) : (
      <button
        data-testid={`admin-cancel-sub-${i}`}
        onClick={() => onCancel(s.id)}
        className="mt-4 rounded-full border border-navy/15 px-4 py-2 text-xs font-semibold text-navy transition-colors hover:border-gold hover:text-gold-dark"
      >
        Résilier
      </button>
    )}
  </article>
);

const PaymentRow = ({ p, i }) => (
  <div data-testid={`admin-payment-row-${i}`} className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-navy/10 bg-white px-5 py-4">
    <div>
      <p className="text-sm font-semibold text-navy">{OFFER_LABELS[p.lookup_key] || p.lookup_key}</p>
      <p className="mt-0.5 max-w-[240px] truncate font-mono text-[10px] text-slate-400">{p.session_id}</p>
    </div>
    <div className="flex items-center gap-3">
      <span className="font-display text-sm font-bold text-navy">{euro(p.amount, p.currency)}</span>
      <span
        className={`rounded-full px-3 py-1 text-[11px] font-semibold ${p.payment_status === "paid" ? "bg-gold/15 text-gold-dark" : "bg-navy/5 text-slate-600"}`}
        data-testid={`admin-payment-status-${i}`}
      >
        {PAYMENT_STATUS_LABELS[p.payment_status] || "En attente"}
      </span>
      <span className="font-mono text-[10px] text-slate-400">{formatDate(p.created_at)}</span>
    </div>
  </div>
);

export const PaymentsTab = ({ subs, payments, onCancelSub }) => (
  <div className="mt-8 space-y-12" data-testid="admin-payments">
    <section>
      <h2 className="font-display text-lg font-bold text-navy">Abonnés Maintenance + Hébergement</h2>
      {subs.length === 0 ? (
        <p className={`mt-5 ${EMPTY_BOX}`} data-testid="admin-subs-empty">
          Aucun abonné pour le moment. Les abonnements maintenance apparaîtront ici.
        </p>
      ) : (
        <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2" data-testid="admin-subs-list">
          {subs.map((s, i) => <SubCard key={s.id} s={s} i={i} onCancel={onCancelSub} />)}
        </div>
      )}
    </section>
    <section>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="font-display text-lg font-bold text-navy">Historique des paiements</h2>
        <ExportButton resource="payments" filename="paiements.csv" label="Exporter en CSV" />
      </div>
      {payments.length === 0 ? (
        <p className={`mt-5 ${EMPTY_BOX}`} data-testid="admin-payments-empty">
          Aucun paiement pour le moment. Les transactions Stripe apparaîtront ici.
        </p>
      ) : (
        <div className="mt-5 space-y-3" data-testid="admin-payments-list">
          {payments.map((p, i) => <PaymentRow key={p.session_id} p={p} i={i} />)}
        </div>
      )}
    </section>
  </div>
);
